import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './NotFoundPage.css';

export const NotFoundPage = () => (
  <>
    <Helmet>
      <title>Page Not Found — Renuit Logistics</title>
    </Helmet>
    <div className="rn-404">
      <span className="rn-404__num">404</span>
      <h1 className="rn-404__heading">Page Not Found</h1>
      <p className="rn-404__body">The page you're looking for doesn't exist or has moved.</p>
      <div className="rn-404__actions">
        <Link to="/" className="cs-button-solid">Back to Home</Link>
        <Link to="/services" className="rn-404__link">View Services →</Link>
      </div>
    </div>
  </>
);
